import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  template: `
    <main class="container py-5">
      <h1>Du har ingen adgang til SAM</h1>
      <p>Kontakt din SAM-administrator for at få tildelt adgang.</p>
    </main>
  `,
})
export class NoAccessComponent {}

@Component({
  standalone: true,
  imports: [RouterLink],
  template: `
    <main class="container py-5">
      <h1>Din adgang kunne ikke kontrolleres</h1>
      <a routerLink="/landing">Prøv igen</a>
    </main>
  `,
})
export class AccessUnavailableComponent {}
